"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _path = _interopRequireDefault(require("path"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Represents a directory that will be created in the target AEM
 * instance. Consist of functionality for ensuring that the
 * remote path of the folder is consistent with the configuration
 * of the upload.
 */
var FileSystemUploadDirectory = /*#__PURE__*/function () {
  /**
   * Constructs a new directory instance with the given values.
   * @param {FileSystemUploadOptions} uploadOptions The URL from
   *  the options will be used to build the remote URL of the
   *  directory.
   * @param {string} localPath Full local path to the directory.
   * @param {string} remoteNodeName The name of the folder's node
   *  as it should appear in AEM.
   * @param {FileSystemUploadDirectory} [parent] Parent directory
   *  for this directory. If not supplied then the directory will
   *  be treated as the root of the upload.
   */
  function FileSystemUploadDirectory(uploadOptions, localPath, remoteNodeName, parent) {
    _classCallCheck(this, FileSystemUploadDirectory);

    this.uploadOptions = uploadOptions;
    this.localPath = localPath;
    this.remoteName = remoteNodeName;
    this.parent = parent;
  }
  /**
   * Retrieves the full, local path of the directory, as provided in
   * the constructor.
   * @returns {string} Local directory path.
   */


  _createClass(FileSystemUploadDirectory, [{
    key: "getLocalPath",
    value: function getLocalPath() {
      return this.localPath;
    }
    /**
     * Retrieves the full, remote path (only) of the item. Will be built
     * using the remote node name provided in the constructor.
     * @returns {string} Path ready for use in a URL.
     */

  }, {
    key: "getRemotePath",
    value: function getRemotePath() {
      var prefix = this.parent ? this.parent.getRemotePath() : this.uploadOptions.getTargetFolderPath();
      return "".concat(prefix, "/").concat(this.getRemoteNodeName());
    }
    /**
     * Retrieves the remote URL of the item's parent.
     * @returns {string} The item parent's URL.
     */

  }, {
    key: "getParentRemoteUrl",
    value: function getParentRemoteUrl() {
      if (!this.parentRemoteUrl) {
        var path = this.parent ? this.parent.getRemotePath() : this.uploadOptions.getTargetFolderPath();
        this.parentRemoteUrl = "".concat(this.uploadOptions.getUrlPrefix()).concat(encodeURI(path));
      }

      return this.parentRemoteUrl;
    }
    /**
     * Retrieves the remote node name of the item, as provided in the
     * constructor.
     * @returns {string} A node name.
     */

  }, {
    key: "getRemoteNodeName",
    value: function getRemoteNodeName() {
      return this.remoteName;
    }
    /**
     * The name of the item as it was originally provided in the local
     * path.
     * @returns {string} Item name.
     */

  }, {
    key: "getName",
    value: function getName() {
      return _path.default.basename(this.localPath);
    }
  }]);

  return FileSystemUploadDirectory;
}();

exports.default = FileSystemUploadDirectory;